// import { useEffect, useMemo, useState, useRef } from "react";
// import { useFormContext } from "react-hook-form";

// import { Input } from "@workspace/web-ui/components/input";
// import { Label } from "@workspace/web-ui/components/label";

// import { WelcomeFormSchema } from "../schema";
// import { InputField } from "../types";
// import { FormContainer, WelcomeStepFormProps } from "./form-container";
// import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select";
// import { ChevronsUpDown } from "lucide-react";

// export function BmiStep({ data, updateFields }: WelcomeStepFormProps) {
//   const {
//     register,
//     watch,
//     setValue,
//     formState: { errors },
//   } = useFormContext<WelcomeFormSchema>();

//   const weightValue = watch("weight");
//   const heightValue = watch("height");

//   // For custom suggestions
//   const [heightDropdownOpen, setHeightDropdownOpen] = useState(false);
//   const inputRef = useRef<HTMLInputElement>(null);
//   const dropdownTimeoutRef = useRef<NodeJS.Timeout>(null);

//   // Auto-close dropdown after 3 seconds of inactivity
//   useEffect(() => {
//     if (heightDropdownOpen) {
//       if (dropdownTimeoutRef.current) {
//         clearTimeout(dropdownTimeoutRef.current);
//       }
//       dropdownTimeoutRef.current = setTimeout(() => {
//         setHeightDropdownOpen(false);
//       }, 5000);
//     }
//     return () => {
//       if (dropdownTimeoutRef.current) {
//         clearTimeout(dropdownTimeoutRef.current);
//       }
//     };
//   }, [heightDropdownOpen, heightValue]);

//   // Parse input and generate suggestions
//   // const heightSuggestions = useMemo(() => {
//   //   if (!heightValue) return [];
    
//   //   // If input is in feet'inches' format, don't show suggestions
//   //   if (/^\d+'(\d+)'?$/.test(heightValue)) return [];
    
//   //   // If input is just a number
//   //   const num = parseInt(heightValue, 10);
//   //   if (isNaN(num)) return [];
    
//   //   let suggestions = [];
    
//   //   // If number is between 4-7, treat as feet
//   //   if (num >= 4 && num <= 7) {
//   //     for (let i = 0; i < 12; i++) {
//   //       suggestions.push({
//   //         label: `${num}'${i}'`,
//   //         value: `${num}'${i}'`,
//   //       });
//   //     }
//   //   }
//   //   // If number is total inches and between 48-84 inches (4-7 feet)
//   //   else if (num >= 48 && num <= 84) {
//   //     const feet = Math.floor(num / 12);
//   //     const inches = num % 12;
//   //     suggestions.push({
//   //       label: `${feet}'${inches}'`,
//   //       value: `${feet}'${inches}'`,
//   //     });
//   //   }
    
//   //   return suggestions;
//   // }, [heightValue]);

//   const feetSuggestions = useMemo(() => {
//     const suggestions = [];
//     for (let i = 4; i <= 7; i++) {
//       suggestions.push({
//         label: `${i}`,
//         value: `${i}`,
//       });
//     }
//     return suggestions;
//   }
//   , []);

//   const inchesSuggestions = useMemo(() => {
//     const suggestions = [];
//     for (let i = 0; i < 12; i++) {
//       suggestions.push({
//         label: `${i}`,
//         value: `${i}`,
//       });
//     }
//     return suggestions;
//   }, []);

//   console.log('weightValue:', weightValue, 'heightValue:', heightValue, 'feetSuggestions:', feetSuggestions, 'inchesSuggestions:', inchesSuggestions);



//   useEffect(() => {
//     updateFields({
//       weight: weightValue,
//       height: heightValue,
//     });
//   }, [weightValue, heightValue, updateFields]);

//   return (
//     <FormContainer heading={data.heading} description={data.description}>
//       {data.form &&
//         (data.form as InputField[]).map((form) => {
//           const name = form.name as keyof WelcomeFormSchema;
//           const { label, type, placeholder } = form;

//           // Render custom suggestions for height
//           if (name === "height") {
//             return (
//               <div className="w-full flex items-center gap-6" key={label}>
//                 {/* <Label
//                   htmlFor={label}
//                   className="mb-4 flex self-start text-left text-lg text-[#7F8493] transition-colors duration-200 ease-in-out peer-checked:text-[#363840]"
//                 >
//                   {label}
//                 </Label>
//                 <div className="relative flex rounded-2xl shadow-md border-2 border-[#F1F1F1] shadow-black/5">
//                   <Input
//                     id={label}
//                     placeholder={placeholder}
//                     type="text"
//                     className="peer border-none focus-visible:ring-0 h-[40px] w-11/12 rounded-s-2xl rounded-e-none p-4 shadow-none sm:h-[60px] lg:h-[80px] lg:w-11/12"
//                     value={heightValue ?? ""}
//                     ref={inputRef}
//                     autoComplete="off"
//                     onChange={e => {
//                       setValue("height", e.target.value, { shouldValidate: true, shouldDirty: true });
//                       const num = parseInt(e.target.value, 10);
//                       if (!isNaN(num) && ((num >= 4 && num <= 7) || (num >= 48 && num <= 84))) {
//                         setHeightDropdownOpen(true);
//                       } else {
//                         setHeightDropdownOpen(false);
//                       }
//                     }}
//                     onFocus={() => {
//                       const num = parseInt(heightValue ?? "", 10);
//                       if (!isNaN(num) && ((num >= 4 && num <= 7) || (num >= 48 && num <= 84))) {
//                         setHeightDropdownOpen(true);
//                       }
//                     }}
//                     onBlur={() => setTimeout(() => setHeightDropdownOpen(false), 200)}
//                   />
//                   {heightDropdownOpen && heightSuggestions.length > 0 && (
//                     <div className="absolute overflow-auto hide-scrollbar h-[100px] left-0 top-[100%] mt-1 w-full min-w-[180px] p-1 bg-white border rounded-lg shadow">
//                       {heightSuggestions.map((opt) => (
//                         <div
//                           key={opt.value}
//                           className="cursor-pointer flex px-2 py-1 hover:bg-gray-100"
//                           onMouseDown={() => {
//                             setValue("height", opt.value, { shouldValidate: true, shouldDirty: true });
//                             setHeightDropdownOpen(false);
//                           }}
//                         >
//                           {opt.label}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                   <span className="z-10 inline-flex w-[72px] items-center justify-center border-l-2 border-[#F1F1F1] rounded-e-2xl bg-white px-3 text-sm text-[#363840]">
//                     Ft
//                   </span>
//                 </div>
//                 {errors.height && (
//                   <p className="text-sm text-[#7F8493]">
//                     <span className="text-sm text-red-500">{errors.height.message}</span>
//                   </p>
//                 )} */}
//                     <Select>
//       <SelectTrigger className="h-[72px] w-full rounded-[16px] border-2 border-[#F1F1F1] shadow-black/5 shadow-md"  noIcon={true}>
//         <div className="w-full">
//           <div className="flex items-center justify-between w-full">
//             <div className="flex items-center justify-between w-full px-2">
//           <SelectValue placeholder="5" className="placeholder:text-[#2D2F35]" />
//           <ChevronsUpDown className="text-[#7F8493]" />
//             </div>
//                 <div className="relative h-[65px] flex">
//                   <span className="z-10 inline-flex w-[72px] items-center justify-center border-l-2 border-[#F1F1F1] rounded-e-2xl bg-white px-3 text-sm text-[#363840]">
//                     Ft
//                   </span>
//                 </div>
//           </div>
//                 {errors.height && (
//                   <p className="text-sm text-[#7F8493]">
//                     <span className="text-sm text-red-500">{errors.height.message}</span>
//                   </p>
//                 )}
//         </div>        
//       </SelectTrigger>
//       <SelectContent className="rounded-[24px]">
//         <SelectGroup>
//           <SelectLabel className="text-2xl font-medium border-b border-[#E6E6E6]">Heights in feet</SelectLabel>
//           {feetSuggestions.map((opt) => (
//             <SelectItem key={opt.value} value={opt.value}>
//               {opt.label}
//             </SelectItem>
//           ))}
//         </SelectGroup>
//       </SelectContent>
//     </Select>
//     <Select>
//       <SelectTrigger className="h-[72px] w-full rounded-[16px] border-2 border-[#F1F1F1] shadow-black/5 shadow-md"  noIcon={true}>
//         <div className="w-full">
//           <div className="flex items-center justify-between w-full">
//             <div className="flex items-center justify-between w-full px-2">
//           <SelectValue placeholder="5" className="placeholder:text-[#2D2F35]" />
//           <ChevronsUpDown className="text-[#7F8493]" />
//             </div>
//                 <div className="relative h-[65px] flex">
//                   <span className="z-10 inline-flex w-[72px] items-center justify-center border-l-2 border-[#F1F1F1] rounded-e-2xl bg-white px-3 text-sm text-[#363840]">
//                     In
//                   </span>
//                 </div>
//           </div>
//                 {errors.height && (
//                   <p className="text-sm text-[#7F8493]">
//                     <span className="text-sm text-red-500">{errors.height.message}</span>
//                   </p>
//                 )}
//         </div>        
//       </SelectTrigger>
//       <SelectContent className="rounded-[24px]">
//         <SelectGroup>
//           <SelectLabel className="text-2xl font-medium border-b border-[#E6E6E6]">Heights in Inches</SelectLabel>
//           {inchesSuggestions.map((opt) => (
//             <SelectItem key={opt.value} value={opt.value}>
//               {opt.label}
//             </SelectItem>
//           ))}
//         </SelectGroup>
//       </SelectContent>
//     </Select>
//               </div>
//             );
//           }

//           // Keep weight as input
//           return (
//             <div className="w-full space-y-2" key={label}>
//               <Label
//                 htmlFor={label}
//                 className="mb-4 flex self-start text-left text-lg text-[#7F8493] transition-colors duration-200 ease-in-out peer-checked:text-[#363840]"
//               >
//                 {label}
//               </Label>
//               <div className="flex rounded-2xl shadow-md border-2 border-[#F1F1F1] shadow-black/5">
//                 <Input
//                   id={label}
//                   placeholder={placeholder}
//                   type={type}
//                   className="peer border-none focus-visible:ring-0 h-[40px] w-11/12 rounded-s-2xl rounded-e-none p-4 shadow-none sm:h-[60px] lg:h-[80px] lg:w-11/12"
//                   {...register(name as keyof WelcomeFormSchema)}
//                 />
//                 <span className="z-10 inline-flex w-[72px] items-center justify-center border-l-2 border-[#F1F1F1] rounded-e-2xl bg-white px-3 text-sm text-[#363840]">
//                   {name === "weight" ? "Lbs" : "Inches"}
//                 </span>
//               </div>
//               {name === "weight" && errors.weight && (
//                 <p className="text-sm text-[#7F8493]">
//                   <span className="text-sm text-red-500">{errors.weight.message}</span>
//                 </p>
//               )}
//             </div>
//           );
//         })}
//     </FormContainer>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";

import { Input } from "@workspace/web-ui/components/input";
import { Label } from "@workspace/web-ui/components/label";

import { WelcomeFormSchema } from "../schema";
import { InputField } from "../types";
import { FormContainer, WelcomeStepFormProps } from "./form-container";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select";
import { ChevronsUpDown } from "lucide-react";

export function BmiStep({ data, updateFields }: WelcomeStepFormProps) {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<WelcomeFormSchema>();

  const weightValue = watch("weight");
  const heightValue = watch("height");
  
  // New state for feet and inches
  const [feet, setFeet] = useState("5");
  const [inches, setInches] = useState("0");

  const feetSuggestions = useMemo(() => {
    const suggestions = [];
    for (let i = 4; i <= 7; i++) {
      suggestions.push({
        label: `${i}`,
        value: `${i}`,
      });
    }
    return suggestions;
  }, []);

  const inchesSuggestions = useMemo(() => {
    const suggestions = [];
    for (let i = 0; i < 12; i++) {
      suggestions.push({
        label: `${i}`,
        value: `${i}`,
      });
    }
    return suggestions;
  }, []);

  // Parse existing height value on component mount
  useEffect(() => {
    if (heightValue) {
      // Parse existing height value (e.g., "5'10'")
      const match = heightValue.match(/^(\d+)'(\d+)'?$/);
      if (match) {
        setFeet(match[1] ?? "");
        setInches(match[2] ?? "");
      }
    }
  }, []);

  // Update height when feet or inches change
  useEffect(() => {
    // Combine feet and inches into height format
    const combinedHeight = `${feet}'${inches}'`;
    setValue("height", combinedHeight, { shouldValidate: true, shouldDirty: true });
    console.log('Final height value:', combinedHeight);
  }, [feet, inches, setValue]);

  // Update parent form
  useEffect(() => {
    updateFields({
      weight: weightValue,
      height: heightValue,
    });
  }, [weightValue, heightValue, updateFields]);

  return (
    <FormContainer heading={data.heading} description={data.description}>
      {data.form &&
        (data.form as InputField[]).map((form) => {
          const name = form.name as keyof WelcomeFormSchema;
          const { label, type, placeholder } = form;

          // Render custom select components for height
          if (name === "height") {
            return (
              <div className="w-full space-y-2" key={label}>
                <Label
                  htmlFor={label}
                  className="mb-4 flex self-start text-left text-lg text-[#7F8493] transition-colors duration-200 ease-in-out peer-checked:text-[#363840]"
                >
                  {label}
                </Label>
                <div className="w-full flex items-center gap-6">
                  <Select value={feet} onValueChange={setFeet}>
                  <SelectTrigger className=" !py-6 w-full rounded-[16px] border-[1px] border-[#F1F1F1] shadow-black/5 shadow-md" noIcon={true}>
                  <div className="w-full">
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center justify-between w-full px-2">
                            <SelectValue placeholder="5" className="placeholder:text-[#2D2F35]" />
                            <ChevronsUpDown className="text-[#7F8493]" />
                          </div>
                          <div className="relative flex">
                            <span className="z-10 inline-flex lg:w-[72px] items-center justify-center border-l-2 border-[#F1F1F1] rounded-e-2xl bg-white px-3 text-sm text-[#363840]">
                              Ft
                            </span>
                          </div>
                        </div>
                      </div>        
                    </SelectTrigger>
                    <SelectContent className="rounded-[18px]">
                      <SelectGroup>
                        <SelectLabel className="text-2xl font-medium border-b border-[#E6E6E6]">Heights in feet</SelectLabel>
                        {feetSuggestions.map((opt) => (
                          <SelectItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                  <Select value={inches} onValueChange={setInches}>
                    <SelectTrigger className=" !py-6 w-full rounded-[16px] border-[1px] border-[#F1F1F1] shadow-black/5 shadow-md" noIcon={true}>
                      <div className="w-full">
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center justify-between w-full px-2">
                            <SelectValue placeholder="0" className="placeholder:text-[#2D2F35]" />
                            <ChevronsUpDown className="text-[#7F8493]" />
                          </div>
                          <div className="relative flex">
                            <span className="z-10 inline-flex lg:w-[72px] items-center justify-center border-l-2 border-[#F1F1F1] rounded-e-2xl bg-white px-3 text-sm text-[#363840]">
                              In
                            </span>
                          </div>
                        </div>
                      </div>        
                    </SelectTrigger>
                    <SelectContent className="rounded-[18px]">
                      <SelectGroup>
                        <SelectLabel className="text-2xl font-medium border-b border-[#E6E6E6]">Heights in Inches</SelectLabel>
                        {inchesSuggestions.map((opt) => (
                          <SelectItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
                {errors.height && (
                  <p className="text-sm text-[#7F8493]">
                    <span className="text-sm text-red-500">{errors.height.message}</span>
                  </p>
                )}
              </div>
            );
          }

          // Keep weight as input
          return (
            <div className="w-full space-y-2" key={label}>
              <Label
                htmlFor={label}
                className="mb-4 flex self-start text-left text-lg text-[#7F8493] transition-colors duration-200 ease-in-out peer-checked:text-[#363840]"
              >
                {label}
              </Label>
              <div className="flex w-full relative rounded-2xl border-gray-200 border shadow-lg shadow-black/5">
              <Input
                  id={label}
                  placeholder={placeholder}
                  type={type}
                  className="peer border-none focus-visible:ring-0 !py-6 w-11/12 rounded-s-2xl rounded-e-none p-4 shadow-none lg:w-11/12"
                  {...register(name as keyof WelcomeFormSchema)}
                />
                <span className="z-10 inline-flex w-[72px] items-center justify-center border-l-2 border-[#F1F1F1] rounded-e-2xl bg-white px-3 text-sm text-[#363840]">
                  {name === "weight" ? "Lbs" : "Inches"}
                </span>
              </div>
              {name === "weight" && errors.weight && (
                <p className="text-sm text-[#7F8493]">
                  <span className="text-sm text-red-500">{errors.weight.message}</span>
                </p>
              )}
            </div>
          );
        })}
    </FormContainer>
  );
}